import { defineMessages } from "react-intl";

export const messages = defineMessages({
  ariaLabel: {
    id: "8BWNS3",
    defaultMessage: "Form progress",
  },
});
